import React from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const HelpLinkText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 500,
  color: '#EF232A',
  textDecoration: 'underline',
  textAlign: 'center',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.8
  }
}));

const SupportEmailText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  color: '#666666',
  textAlign: 'center',
  marginTop: '12px'
}));

const HelpLink = ({ onClick }) => {
  return (
    <Box>
      <HelpLinkText onClick={onClick}>
        Unable to trace account ?
      </HelpLinkText>
      <SupportEmailText>
        Need help? Email us at{' '}
        <a href="mailto:support@visibeen.com" style={{ color: '#0B91D6', textDecoration: 'none' }}>
          support@visibeen.com
        </a>
      </SupportEmailText>
    </Box>
  );
};

export default HelpLink;